import React from 'react';
import { Dropdown } from 'carbon-components-react';
import { ReportSelectorProps } from '../../types';

export const ReportSelector: React.FC<ReportSelectorProps> = ({
  reports,
  selectedReportId,
  onSelect,
  disabled
}) => {
  // Format reports for Carbon Dropdown
  const items = reports.map((report) => ({
    ...report,
    label: report.name
  }));

  const selectedItem =
    items.find((item) => item.id === selectedReportId) || null;

  return (
    <div className="report-selector">
      <Dropdown
        id="report-selector-dropdown"
        titleText="Report type"
        label="Select a report..."
        items={items}
        itemToString={(item) => (item ? item.label : '')}
        selectedItem={selectedItem}
        onChange={({ selectedItem: selected }) => {
          if (selected) {
            onSelect(selected.id);
          }
        }}
        disabled={disabled}
        size="xl"
      />
      {selectedItem && (
        <p
          style={{
            marginTop: '0.5rem',
            fontSize: '0.875rem',
            color: '#6f6f6f'
          }}
        >
          {selectedItem.description}
        </p>
      )}
    </div>
  );
};

export default React.memo(ReportSelector);
